import Links from '@/shared/constants/navegacao';

/** Rotas do processo seletivo acessíveis sem login no SGI (candidato anônimo ou token próprio). */
export function isRotaPublicaCandidato(pathname: string): boolean {
  return (
    pathname.startsWith(`${Links.Candidato_Inscricao}/`) ||
    pathname === Links.Candidato_Inscricao_Confirmacao ||
    pathname === '/candidato/login' ||
    pathname === '/candidato/meus-processos' ||
    pathname.startsWith(`${Links.ProcessoSeletivo_NaoDisponivel}/`)
  );
}
